namespace $ {

	export type $shm_hitalama_map_widget_entity_drawing_point = readonly [ number, number ]

	export type $shm_hitalama_map_widget_entity_drawing_line = {
		readonly color: string
		readonly width: number
		readonly points: readonly $shm_hitalama_map_widget_entity_drawing_point[]
	}

	export class $shm_hitalama_map_widget_entity_drawing extends $giper_baza_entity.with({

		Lines: $giper_baza_atom_list,
		Line_color: $giper_baza_atom_text,
		Line_width: $giper_baza_atom_real,
		Draft: $giper_baza_atom_bool,

	}) {

		lines( next?: readonly $shm_hitalama_map_widget_entity_drawing_line[] ) {
			return ( this.Lines(next as any)?.val(next as any) ?? [] ) as readonly $shm_hitalama_map_widget_entity_drawing_line[]
		}

		color( next?: string ) {
			return this.Line_color(next)?.val(next) ?? '#808080'
		}

		width( next?: number ) {
			return this.Line_width(next)?.val(next) ?? 4
		}

		draft( next?: boolean ) {
			return this.Draft(next)?.val(next) ?? false
		}

		line_add( line: $shm_hitalama_map_widget_entity_drawing_line ) {
			const index = this.lines().length
			this.lines([ ... this.lines(), line ])
			return index
		}

		line_update( index: number, line: $shm_hitalama_map_widget_entity_drawing_line ) {
			const lines = [ ... this.lines() ]
			lines[ index ] = line
			this.lines( lines )
			return line
		}

		box() {
			const points = this.lines().flatMap( line => line.points )
			if( points.length === 0 ) return null

			const widths = this.lines().map( line => line.width )
			const pad = Math.max( 1, ... widths ) / 2 + 2

			let left = Infinity
			let top = Infinity
			let right = -Infinity
			let bottom = -Infinity

			for( const point of points ) {
				left = Math.min( left, point[0] )
				top = Math.min( top, point[1] )
				right = Math.max( right, point[0] )
				bottom = Math.max( bottom, point[1] )
			}

			return {
				left: left - pad,
				top: top - pad,
				right: right + pad,
				bottom: bottom + pad,
				width: Math.max( 1, right - left + pad * 2 ),
				height: Math.max( 1, bottom - top + pad * 2 ),
			}
		}

	}

}
